import TotalTable from './TotalTable';
import { withI18n } from 'react-i18next';
export default withI18n()(TotalTable);
